import { render, staticRenderFns } from "./CCMVitalEntryEdit.vue?vue&type=template&id=22383c1b"
import script from "./CCMVitalEntryEdit.vue?vue&type=script&lang=js"
export * from "./CCMVitalEntryEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports